import { ACTION_TYPE_INITIALIZE } from './actionTypes';
export const initialize = (config)=>({
        type: ACTION_TYPE_INITIALIZE,
        config
    });
